import { DepartmentDto } from "../../autogen/bff-api";

// Counts retired departments too: this asks whether department wording belongs on the screen at
// all, and what a retired one already owns still has to say which department that is.
export const organizationHasSeveralDepartments = (org: { departments?: DepartmentDto[] }): boolean =>
  (org.departments ?? []).length > 1;

export const selectableDepartments = <T extends { active: boolean }>(departments: T[]): T[] =>
  departments.filter((d) => d.active);

// BFF Profiles.kt gates PUBLISH on HomeDepartmentPresent: hide an unset one and the draft is stuck.
export const showsHomeDepartment = (
  org: { departments?: DepartmentDto[] },
  homeDepartmentId: string | null | undefined
): boolean => organizationHasSeveralDepartments(org) || !homeDepartmentId;

// BFF Need.missingRequiredFields gates the report on departmentId: hide an unset one and the draft is stuck.
export const showsNeedDepartment = (
  org: { departments?: DepartmentDto[] },
  departmentId: string | null | undefined
): boolean => organizationHasSeveralDepartments(org) || !departmentId;
